import {
  overrideRateResponseSchema,
  type OverrideRateResponse,
} from '@lms/shared-types'
import { apiRequest } from './client'

export type { OverrideRateResponse }

/**
 * GET /api/v1/hr/override-rate
 *
 * Returns override-rate analytics for a date range, grouped by manager,
 * reason, or month. Accessible to HR / Director / Exec Director.
 *
 * Throws `ApiError` for:
 *   - 401 — unauthenticated
 *   - 403 — insufficient role
 *   - 422 — invalid query params (e.g. malformed date)
 */
export async function getOverrideRate(params: {
  from?: string
  to?: string
  group_by?: 'manager' | 'reason' | 'month'
}): Promise<OverrideRateResponse> {
  const qs = new URLSearchParams()
  if (params.from != null) qs.set('from', params.from)
  if (params.to != null) qs.set('to', params.to)
  if (params.group_by != null) qs.set('group_by', params.group_by)

  const query = qs.toString()
  const url = `/api/v1/hr/override-rate${query ? `?${query}` : ''}`
  const raw = await apiRequest<unknown>(url)
  return overrideRateResponseSchema.parse(raw)
}
